<template>
    <div id="Preview">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="container-fluid">
                    <div class="page-name">
                        <div class="page-title"> {{fromPage}} Preview</div>
                        <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="PurchaseOrderList">
                        <i class="fp-back"> </i> Back
                        </button>
                    </div>
                    <!--page content-->
                    <div class="admin-page-content purchase-order-view">
                        <section class="bg-white">
                            <div class="container">
                                <div class="notice-modal">
                                    <!-- <h5 class="modal-title">Email Content</h5> -->
                                    <h5 style="float:right;" id='sent_date'></h5>
                                    <p>&nbsp;</p>
                                    <div class="mailBody">
                                        TO: &nbsp;<span id='toMail'></span><br>
                                        <p>CC: &nbsp;<span id="ccMail"></span></p>
                                    </div>
                                    <div class="modal-body">

                                    </div>
                                    <div class="mailBody">
                                    </div>
                                    <div class="modal-footer">
                                        <!--<button class="btn btn-primary" id="download_inv_btn" v-on:click="viewInvoice(BookData.bookingId,'download')">Download</button>-->
                                        <button type="button" v-if="from == 'Po'" class="btn btn-primary" v-on:click="sendPo">Send</button>
                                        <button type="button" v-if="from == 'custEst'" class="btn btn-primary" v-on:click="sendCustomerEst">Send</button>
                                        <button type="button" v-if="from == 'Po'" class="btn btn-primary" v-on:click="viewMailTemplate('download')">Download</button>
                                        <button type="button" v-if="from == 'custEst'" class="btn btn-primary" v-on:click="viewCustEstTemplate('download')">Download</button>
                                    </div>

                                </div>
                            </div>
                        </section>
                    </div>

                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>Oops!</h1>
                        <h2>403</h2>
                        <div class="error-details">Sorry!, You don't have permission to access this page.</div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>

    </div>
</template>
<script>

    import Vue from 'vue';
    import {commonMixins} from '../mixins/commonMixins';

    import {dataTableMixins} from '../mixins/dataTableMixins';




    export default {
        name: "preview",
        mixins:[commonMixins,dataTableMixins],
        data: () => ({
             permissions: [],
            cantAccessPage: true,
            firstLoad : 0,
            loading:false,
            modalLoading:false,
            fileName:'',
            workOrdeEstimatePath:'',
            googleUrl:'',
            poId:'',
            flag:'',
            from:'',
            fromPage:'',
            estId:'',
            ccView:false,
            cust_id:0,
        }),
        watch: {
            //check permission change
            permissions: function (permissions) {
                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'view_purchase_order' || permissions[i].name == 'view_customer_estimate') {
                            self.cantAccessPage = true;
                        }
                    }
                }

            }
        },
        created: function() {
        },
        mounted: function () {

            var self = this;

            self.getPermissions();
            var webloc = window.location.href;

            var decodeStr = "";

            if ( this.$route.query.data != '' && this.$route.query.data != undefined ) {

                decodeStr = atob(this.$route.query.data)

            }

            var url = new URL(webloc+"?"+decodeStr);
            self.from = url.searchParams.get("from");
            if ( self.from == 'Po'){
                self.poId = url.searchParams.get("poId");
            }
            if ( self.from == 'custEst'){

                self.cust_id = url.searchParams.get("cust_id");
                self.estId = url.searchParams.get("estId");
            }

            self.flag = url.searchParams.get("flag");

            setTimeout(function () {

                if ( self.from == 'Po'){

                    self.viewMailTemplate('')
                    self.fromPage = 'Purchase Order'
                }

                if ( self.from == 'custEst'){

                    self.viewCustEstTemplate('')
                    self.fromPage = 'Customer Estimate'
                }


            },200);

        },
        metaInfo() {
            var metaTitle = "FleetPro Application";
            if (this.from == "custEst") {
                metaTitle = "Customer Estimate Preview | " +process.env.COPYRIGHT_NAME;
            }else if (this.from == "Po") {
                metaTitle = "Purchase Order Preview | " +process.env.COPYRIGHT_NAME;
            }
            return {
                title: metaTitle
            }
        },
        methods: {

            viewMailTemplate(task){

                var self = this;

                self.loading = true;

                $.ajax({
                    url: process.env.ROOT_API + "/get-po-template",
                    type: "GET",
                    data: {id:self.poId,
                    flag:self.flag,
                    task:task},
                    headers: this.ajxHeaders,
                    success: function (data) {
                        self.loading = false;
                        if (task == 'download'){

                            var link = document.createElement('a');
                            document.body.appendChild(link);
                            link.href = data;
                            link.download = '';
                            link.target = "_blank";
                            link.click();
                        }else{
                            $(".modal-body").html("");
                            $('#toMail').text(data.to);
                            if (data.cc && data.cc != ''){

                                $('#ccMail').text(data.cc);

                            }else{

                                $('#ccMail').text('-');
                            }
                            $(".modal-body").html(data.view);
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.modalLoading = false;
                        self.reqeustSent = 0;

                        self.loading = false;
                        if (jqXHR.status == 0) {
                            self.errorMsg = "Remote server cannot be reached";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("tkn");
                                self.$router.push("/");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });

            },
            viewCustEstTemplate(task){

                var self = this;

                self.loading = true;

                $.ajax({
                    url: process.env.ROOT_API + "/get-cust-est-template",
                    type: "GET",
                    data: {id:self.estId,
                    flag:self.flag,
                    cust_id:self.cust_id,
                    task:task},
                    headers: this.ajxHeaders,
                    success: function (data) {
                        self.loading = false;
                        if (task == 'download'){

                            var link = document.createElement('a');
                            document.body.appendChild(link);
                            link.href = data;
                            link.download = '';
                            link.target = "_blank";
                            link.click();
                        }else{

                           $(".modal-body").html("");

                            $('#toMail').text(data.to);
                            if (data.cc && data.cc != ''){

                                $('#ccMail').text(data.cc);

                            }else{

                                $('#ccMail').text('-');
                            }

                            $(".modal-body").html(data.view);
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.modalLoading = false;
                        self.reqeustSent = 0;

                        self.loading = false;
                        if (jqXHR.status == 0) {
                            self.errorMsg = "Remote server cannot be reached";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("tkn");
                                self.$router.push("/");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });

            },
            sendPo(){
                var self = this;
                self.loading = true;
                $.ajax({
                    url: process.env.ROOT_API + '/purchase-order/send',
                    type: "POST",
                    data: {
                    po_id:self.poId,
                    flag:self.flag
                    },
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {

                        self.loading = false;
                        if ( data.code == 201){

                            self.$swal('',data.message,'info');
                        }
                        if( data.code == 200){

                            self.$swal('',data.message,'success');
                            self.$router.push("/order-history/list");

                        }
                        // self.loadWorkOrderEstimate();
                    // self.$router.push('/customer-estimate/view/'+data.content);
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'po-sent-from-preview');
                    }
                });
            },
            sendCustomerEst(){
                var self = this;

                var field = [];
                field[0] = {};
                field[0]['id'] = self.estId;
                field[0]['cust_id'] = self.cust_id;
                self.loading = true;
                $.ajax({
                    url: process.env.ROOT_API + '/customer-estimate/send',
                    type: "POST",
                    data: {
                    arr:field,
                    flag:self.flag
                    },
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {

                        self.loading = false;
                        self.$swal('',data.content,'success');
                        // self.loadWorkOrderEstimate();
                        self.$router.push('/estimate');
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'customer-estimate-sent-from-preview');
                    }
                });
            },
            PurchaseOrderList() {
                var self = this;

                if ( self.from == 'Po'){

                    self.$router.push("/order-history/list");

                }

                if ( self.from == 'custEst'){

                    self.$router.push("/estimate");

                }
            },
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/PurchaseOrderPreview.vue